// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Perimetre geographique d'intervention : carte de France par lot technique. Taille et habillage
   calques sur la carte d'affectation de la gestion d'equipe (.affectation-carte-mapcard) -> parite. */
.zones-carte {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

/* Barre : selecteur de lot (meme largeur que le panneau de la gestion d'equipe : 30rem). */
.zones-carte-toolbar {
  display: flex;
  align-items: flex-end;
  gap: 2.5rem;
}
/* Toggle Carte / Liste : serre a droite, aligne sur le bas du selecteur (comme la gestion d'equipe). */
.zones-carte-toolbar .view-switch {
  margin-left: auto;
  align-self: flex-end;
}
.zones-carte-field {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  width: 30rem;
  max-width: 100%;
}
.zones-carte-field span {
  font-size: 1.2rem;
  font-weight: 600;
  color: #595959;
}
.zones-carte-field select {
  width: 100%;
  padding: 0.7rem 0.9rem;
  border: 1px solid #d1d5db;
  border-radius: 0.6rem;
  font-size: 1.3rem;
  font-family: inherit;
  color: #374151;
  background: #ffffff;
  cursor: pointer;
}
.zones-carte-field select:focus {
  outline: none;
  border-color: #f97316;
  box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.1);
}
/* Champ filtre (region/departement) : largeur propre, ne suit pas le selecteur de lot. */
.zones-carte-field--filtre {
  width: auto;
}
.zones-carte-field--filtre select {
  width: 24rem;
}

/* Consigne (Banner info) : la marge est geree par le gap du conteneur. */
.zones-carte-consigne {
  margin: 0;
}

/* Tuile carte : meme habillage et meme taille que .affectation-carte-mapcard (gestion d'equipe). */
.zones-carte-mapcard {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60rem;
  padding: 1.8rem;
  background: #fafbfc;
  border: 1px solid #eef0f2;
  border-radius: 1.2rem;
}
.zones-carte-mapcard .carte-affectation {
  width: 100%;
  max-width: 460px;
}

/* ── Vue liste : table facon gestion d'equipe (ListeAffectation). Boite scrollable, hauteur calee
   sur la carte (60rem) pour que la bascule ne fasse pas sauter la mise en page. ── */
.zones-liste {
  max-height: 60rem;
  overflow-y: auto;
  background: #ffffff;
  border: 1px solid #eef0f2;
  border-radius: 1.2rem;
}
.zones-liste-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 1.3rem;
}
/* En-tete de groupe (region) pour les lots departementaux. Colle en haut au scroll. */
.zones-liste-group td {
  position: sticky;
  top: 0;
  background: #f8fafc;
  color: #595959;
  font-weight: 700;
  font-size: 1.1rem;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  padding: 0.7rem 1.2rem;
  border-bottom: 1px solid #eef0f2;
}
.zones-liste-row {
  border-bottom: 1px solid #f1f5f9;
  color: #374151;
}
.zones-liste-row.is-actionnable {
  cursor: pointer;
}
.zones-liste-row.is-actionnable:hover {
  background: #f9fafb;
}
.zones-liste-row td {
  padding: 0.7rem 1.2rem;
  vertical-align: middle;
}
.zones-liste-col-sel {
  width: 3.4rem;
}
.zones-liste-col-sel input {
  width: 1.6rem;
  height: 1.6rem;
  accent-color: #f97316;
  cursor: inherit;
}
.zones-liste-nom {
  width: 100%;
}
.zones-liste-col-tag {
  text-align: right;
  white-space: nowrap;
}
.zones-liste-tag {
  display: inline-block;
  padding: 0.2rem 0.7rem;
  border-radius: 999px;
  font-size: 1.1rem;
  font-weight: 600;
  color: #9ca3af;
}
.zones-liste-tag.is-couvert {
  background: rgba(249, 115, 22, 0.12);
  color: #c2410c;
}
.zones-liste-tag.is-titulaire {
  background: rgba(194, 65, 12, 0.12);
  color: #9a3412;
}

.zones-carte-empty {
  font-size: 1.4rem;
  color: #9ca3af;
  text-align: center;
  padding: 3rem 0;
}

/* Legende (mode libre) : zone libre vs deja titulaire. */
.zones-carte-legende {
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
}
.zones-carte-legende-item {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.2rem;
  color: #374151;
}
.zones-carte-pastille {
  width: 1.4rem;
  height: 1.4rem;
  border-radius: 0.3rem;
  border: 1px solid rgba(0, 0, 0, 0.12);
  flex-shrink: 0;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Profil/components/PrestataireZonesCarte.css"],"names":[],"mappings":"AAAA;sGACsG;AACtG;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA,2FAA2F;AAC3F;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;AACb;AACA,uGAAuG;AACvG;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;AACA,yFAAyF;AACzF;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;;AAEA,yEAAyE;AACzE;EACE,SAAS;AACX;;AAEA,mGAAmG;AACnG;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;qFACqF;AACrF;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;AACA,sFAAsF;AACtF;EACE,gBAAgB;EAChB,MAAM;EACN,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;AAClC;AACA;EACE,gCAAgC;EAChC,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,cAAc;EACd,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,oCAAoC;EACpC,cAAc;AAChB;AACA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA,yDAAyD;AACzD;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,aAAa;EACb,cAAc;EACd,qBAAqB;EACrB,qCAAqC;EACrC,cAAc;AAChB","sourcesContent":["/* Perimetre geographique d'intervention : carte de France par lot technique. Taille et habillage\n   calques sur la carte d'affectation de la gestion d'equipe (.affectation-carte-mapcard) -> parite. */\n.zones-carte {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n/* Barre : selecteur de lot (meme largeur que le panneau de la gestion d'equipe : 30rem). */\n.zones-carte-toolbar {\n  display: flex;\n  align-items: flex-end;\n  gap: 2.5rem;\n}\n/* Toggle Carte / Liste : serre a droite, aligne sur le bas du selecteur (comme la gestion d'equipe). */\n.zones-carte-toolbar .view-switch {\n  margin-left: auto;\n  align-self: flex-end;\n}\n.zones-carte-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  width: 30rem;\n  max-width: 100%;\n}\n.zones-carte-field span {\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: #595959;\n}\n.zones-carte-field select {\n  width: 100%;\n  padding: 0.7rem 0.9rem;\n  border: 1px solid #d1d5db;\n  border-radius: 0.6rem;\n  font-size: 1.3rem;\n  font-family: inherit;\n  color: #374151;\n  background: #ffffff;\n  cursor: pointer;\n}\n.zones-carte-field select:focus {\n  outline: none;\n  border-color: #f97316;\n  box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.1);\n}\n/* Champ filtre (region/departement) : largeur propre, ne suit pas le selecteur de lot. */\n.zones-carte-field--filtre {\n  width: auto;\n}\n.zones-carte-field--filtre select {\n  width: 24rem;\n}\n\n/* Consigne (Banner info) : la marge est geree par le gap du conteneur. */\n.zones-carte-consigne {\n  margin: 0;\n}\n\n/* Tuile carte : meme habillage et meme taille que .affectation-carte-mapcard (gestion d'equipe). */\n.zones-carte-mapcard {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 60rem;\n  padding: 1.8rem;\n  background: #fafbfc;\n  border: 1px solid #eef0f2;\n  border-radius: 1.2rem;\n}\n.zones-carte-mapcard .carte-affectation {\n  width: 100%;\n  max-width: 460px;\n}\n\n/* ── Vue liste : table facon gestion d'equipe (ListeAffectation). Boite scrollable, hauteur calee\n   sur la carte (60rem) pour que la bascule ne fasse pas sauter la mise en page. ── */\n.zones-liste {\n  max-height: 60rem;\n  overflow-y: auto;\n  background: #ffffff;\n  border: 1px solid #eef0f2;\n  border-radius: 1.2rem;\n}\n.zones-liste-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 1.3rem;\n}\n/* En-tete de groupe (region) pour les lots departementaux. Colle en haut au scroll. */\n.zones-liste-group td {\n  position: sticky;\n  top: 0;\n  background: #f8fafc;\n  color: #595959;\n  font-weight: 700;\n  font-size: 1.1rem;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  padding: 0.7rem 1.2rem;\n  border-bottom: 1px solid #eef0f2;\n}\n.zones-liste-row {\n  border-bottom: 1px solid #f1f5f9;\n  color: #374151;\n}\n.zones-liste-row.is-actionnable {\n  cursor: pointer;\n}\n.zones-liste-row.is-actionnable:hover {\n  background: #f9fafb;\n}\n.zones-liste-row td {\n  padding: 0.7rem 1.2rem;\n  vertical-align: middle;\n}\n.zones-liste-col-sel {\n  width: 3.4rem;\n}\n.zones-liste-col-sel input {\n  width: 1.6rem;\n  height: 1.6rem;\n  accent-color: #f97316;\n  cursor: inherit;\n}\n.zones-liste-nom {\n  width: 100%;\n}\n.zones-liste-col-tag {\n  text-align: right;\n  white-space: nowrap;\n}\n.zones-liste-tag {\n  display: inline-block;\n  padding: 0.2rem 0.7rem;\n  border-radius: 999px;\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #9ca3af;\n}\n.zones-liste-tag.is-couvert {\n  background: rgba(249, 115, 22, 0.12);\n  color: #c2410c;\n}\n.zones-liste-tag.is-titulaire {\n  background: rgba(194, 65, 12, 0.12);\n  color: #9a3412;\n}\n\n.zones-carte-empty {\n  font-size: 1.4rem;\n  color: #9ca3af;\n  text-align: center;\n  padding: 3rem 0;\n}\n\n/* Legende (mode libre) : zone libre vs deja titulaire. */\n.zones-carte-legende {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1.5rem;\n}\n.zones-carte-legende-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 1.2rem;\n  color: #374151;\n}\n.zones-carte-pastille {\n  width: 1.4rem;\n  height: 1.4rem;\n  border-radius: 0.3rem;\n  border: 1px solid rgba(0, 0, 0, 0.12);\n  flex-shrink: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
